// import css from "./product.module.css";
// import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import { db } from "../../firebase";

// export default function Hero({ oneProd }) {
//   const navigate = useNavigate();
//   const [heroData, setHeroData] = useState(null);

//   const hasRealText = (value) => {
//     if (value === null || value === undefined) return false;

//     return (
//       String(value)
//         .replace(/\u00A0/g, " ")
//         .trim().length > 0
//     );
//   };

//   const heroPhoto = oneProd?.heroFoto;
//   const heroTitle = oneProd?.heroLabelText;
//   const heroDescription = oneProd?.heroParagrafText;
//   const heroName = oneProd?.bookHero;

//   const shouldShowHeroBlock =
//     hasRealText(heroPhoto) &&
//     hasRealText(heroTitle) &&
//     hasRealText(heroDescription);

//   useEffect(() => {
//     const fetchHeroData = async () => {
//       if (!shouldShowHeroBlock || !hasRealText(heroName)) {
//         setHeroData(null);
//         return;
//       }

//       try {
//         const heroQuery = query(
//           collection(db, "hero"),
//           where("name", "==", String(heroName).trim()),
//         );

//         const querySnapshot = await getDocs(heroQuery);

//         if (querySnapshot.empty) {
//           setHeroData(null);
//           return;
//         }

//         const firstHeroDoc = querySnapshot.docs[0];

//         const foundHero = {
//           id: firstHeroDoc.id,
//           ...firstHeroDoc.data(),
//         };

//         /*
//          * Якщо герой прихований, не записуємо його в heroData.
//          * Блок у товарі при цьому продовжує відображатися,
//          * бо його показ контролює shouldShowHeroBlock.
//          */
//         if (foundHero.showOnSite === false) {
//           setHeroData(null);
//           return;
//         }

//         setHeroData(foundHero);
//       } catch (error) {
//         console.error("Помилка при отриманні героя:", error);
//         setHeroData(null);
//       }
//     };

//     fetchHeroData();
//   }, [heroName, shouldShowHeroBlock]);

//   const goToHeroPage = () => {
//     if (!heroData?.uid) return;

//     navigate(`/hero/${heroData.uid}`);
//   };

//   if (!oneProd || !shouldShowHeroBlock) {
//     return null;
//   }

//   return (
//     <div className={css.heroWrapp}>
//       <div className={css.heroPicRo}>
//         <div className={css.heroPicRoteta}>
//           <img
//             src={String(heroPhoto).trim()}
//             className={css.theSameHeroPic}
//             alt={String(heroTitle).trim()}
//           />
//         </div>
//       </div>

//       <div className={css.wrapHeroText}>
//         <h1 className={css.wrapHeroTextH1}>{String(heroTitle).trim()}</h1>

//         <p className={css.wrapHeroTextP}>{String(heroDescription).trim()}</p>

//         {heroData?.uid && (
//           <button onClick={goToHeroPage} className={css.heroButton}>
//             Сторінка героя
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }
import css from "./product.module.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export default function Hero({ oneProd }) {
  const navigate = useNavigate();

  /*
   * undefined — ще триває перевірка;
   * null — героя немає або він прихований;
   * object — героя знайдено.
   */
  const [heroData, setHeroData] = useState(undefined);

  const hasRealText = (value) => {
    if (value === null || value === undefined) return false;

    return (
      String(value)
        .replace(/\u00A0/g, " ")
        .trim().length > 0
    );
  };

  const heroPhoto = oneProd?.heroFoto;
  const heroTitle = oneProd?.heroLabelText;
  const heroDescription = oneProd?.heroParagrafText;
  const heroName = oneProd?.bookHero;

  const hasHeroProductData =
    hasRealText(heroPhoto) &&
    hasRealText(heroTitle) &&
    hasRealText(heroDescription) &&
    hasRealText(heroName);

  useEffect(() => {
    let isActive = true;

    const fetchHeroData = async () => {
      // Починаємо нову перевірку героя
      setHeroData(undefined);

      if (!hasHeroProductData) {
        setHeroData(null);
        return;
      }

      try {
        const heroQuery = query(
          collection(db, "hero"),
          where("name", "==", String(heroName).trim()),
        );

        const querySnapshot = await getDocs(heroQuery);

        if (!isActive) return;

        // Якщо героя з таким name немає — приховуємо весь блок
        if (querySnapshot.empty) {
          setHeroData(null);
          return;
        }

        const firstHeroDoc = querySnapshot.docs[0];

        const foundHero = {
          id: firstHeroDoc.id,
          ...firstHeroDoc.data(),
        };

        // Якщо герой прихований — також приховуємо весь блок
        if (foundHero.showOnSite === false) {
          setHeroData(null);
          return;
        }

        // Без uid перейти на сторінку героя неможливо,
        // тому такий блок також не показуємо
        if (!hasRealText(foundHero.uid)) {
          setHeroData(null);
          return;
        }

        setHeroData(foundHero);
      } catch (error) {
        console.error("Помилка при отриманні героя:", error);

        if (isActive) {
          setHeroData(null);
        }
      }
    };

    fetchHeroData();

    return () => {
      isActive = false;
    };
  }, [heroName, heroPhoto, heroTitle, heroDescription, hasHeroProductData]);

  const goToHeroPage = () => {
    if (!heroData?.uid) return;

    navigate(`/hero/${heroData.uid}`);
  };

  /*
   * Не показуємо блок, коли:
   * 1. товар ще не завантажився;
   * 2. поля героя в товарі не заповнені;
   * 3. триває перевірка Firestore;
   * 4. героя немає;
   * 5. герой прихований;
   * 6. у героя немає uid.
   */
  if (!oneProd || !hasHeroProductData || !heroData?.uid) {
    return null;
  }

  return (
    <div className={css.heroWrapp}>
      <div className={css.heroPicRo}>
        <div className={css.heroPicRoteta}>
          <img
            src={String(heroPhoto).trim()}
            className={css.theSameHeroPic}
            alt={String(heroTitle).trim()}
          />
        </div>
      </div>

      <div className={css.wrapHeroText}>
        <h1 className={css.wrapHeroTextH1}>{String(heroTitle).trim()}</h1>

        <p className={css.wrapHeroTextP}>{String(heroDescription).trim()}</p>

        <button type="button" onClick={goToHeroPage} className={css.heroButton}>
          Сторінка героя
        </button>
      </div>
    </div>
  );
}
